import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import imageWheel from "../assets/wheel.webp";
import imagePaddle from "../assets/paddle.png";

export default function SpinOffer() {
  const [currentReward, setCurrentReward] = useState(null);
  const [rewardText, setRewardText] = useState("");
  const [isSpinning, setIsSpinning] = useState(false);

  const wheelRef = useRef(null);
  const navigate = useNavigate();

  const rewards = [
    {
      label: "40% discount",
      message: 40,
      weight: 10,
    },
    {
      label: "30% discount",
      message: 30,
      weight: 20,
    },
    {
      label: "20% discount",
      message: 20,
      weight: 20,
    },
    {
      label: "10% discount",
      message: 10,
      weight: 50,
    },
    {
      label: "0% discount",
      message: 0,
      weight: 20,
    },
    {
      label: "50% discount",
      message: 50,
      weight: 1,
    },
  ];

  const weights = rewards.map((reward) => reward.weight);
  const totalWeight = weights.reduce((total, weight) => total + weight, 0);

  const spinWheel = () => {
    setIsSpinning(true);
    const random = Math.floor(Math.random() * totalWeight);
    let cumulativeWeight = 0;
    let chosenReward = null;

    for (let i = 0; i < rewards.length; i++) {
      cumulativeWeight += weights[i];
      if (random < cumulativeWeight) {
        chosenReward = rewards[i];
        break;
      }
    }

    setCurrentReward(chosenReward);

    setRewardText("");

    const rotation = (360 / rewards.length) * rewards.indexOf(chosenReward);
    const spinDuration = 8;

    if (wheelRef.current) {
      wheelRef.current.style.transition = `transform ${spinDuration}s cubic-bezier(0.33, 0.08, 0.38, 1.23)`;
      wheelRef.current.style.transform = `rotate(${360 * spinDuration + rotation
        }deg)`;

      setTimeout(() => {
        if (wheelRef.current) wheelRef.current.style.transition = "";
        localStorage.setItem("reward", chosenReward?.message);
        navigate("/success");
      }, spinDuration * 1100);
    }
  };

  return (
    <div className="spin-offer-container">
      <h1 className="spin-offer-title">
        <span>Spin the Wheel for a Discount!</span>
      </h1>
      <div className="spin-wheel-container">
        <div className="wheel-container">
          <img
            ref={wheelRef}
            src={imageWheel}
            alt="spin wheel"
            className="wheel-image"
          />
          <img src={imagePaddle} alt="wheel pointer" className="paddle-image" />
        </div>

        <div className="button-container">
          <button
            onClick={spinWheel}
            className="spin-button"
            style={{ cursor: isSpinning ? "not-allowed" : "pointer" }}
          >
            SPIN WHEEL
          </button>
        </div>

        <div
          className="reward-text"
          dangerouslySetInnerHTML={{ __html: rewardText }}
        ></div>
      </div>
    </div>
  );
}
